// extracted by mini-css-extract-plugin
export default {"narrator":"styles_narrator__UR3P6","mainImg":"styles_mainImg__7-jsZ","lang":"styles_lang__jTpYJ","name":"styles_name__4IqOh","title":"styles_title__9QgEj","ico":"styles_ico__Grank"};